import Layout from "../../components/layout/Layout"; 
import CrewList from "../../components/crew/crewList";
import CastingCallSlide from "../../components/castingCalls/castingCallSlide";

function ActorCrew() {
  return (
    <Layout>
      <div>
        <CastingCallSlide />
        <CrewList />
      </div>
    </Layout>
  );
}

export default ActorCrew;
